import { useAddWorkspace } from "hooks/useAddWorkspace";
import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, useTheme } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export const WorkspaceAddComponent = (props: { onClose: () => void; onActionSuccess: () => void; open: boolean}) => {
    const [name, setName] = useState('')
    const { t } = useTranslation();
    const theme = useTheme();
    const { addWorkspace, addingWorkspace } = useAddWorkspace();

    const handleAddWorkspace = async () => {
        const resp = await addWorkspace({ name });
        if (resp?.success && resp.data) {
            props.onActionSuccess();
            props.onClose();
        }
    }

    return <Dialog open={props.open} onClose={() => {}}>
        <DialogTitle>{t('admin.addWorkspace')}</DialogTitle>
        <DialogContent>
            <TextField
                autoFocus
                margin="dense"
                id="name"
                label={t('admin.workspaceName')}
                type="text"
                fullWidth
                value={name}
                onChange={(event) => setName(event.target.value)}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onClose()}>{t('admin.cancel')}</Button>
            <LoadingButton loading={addingWorkspace} onClick={handleAddWorkspace}>{t('admin.add')}</LoadingButton>
        </DialogActions>
    </Dialog>
}